import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
const deleteSupplierAccountsByPkMutation = gql`mutation delete_supplier_accounts_by_pk($id: uuid!){
  delete_supplier_accounts_by_pk(id: $id){
    id
  }
}`;

@Injectable({
  providedIn: 'root'
})
export class DeleteAccountByPkService {

  constructor(
    private apollo: Apollo) { }

  deleteSupplierAccountByPk(id: string){
    return this.apollo.use('external').mutate({
      mutation: deleteSupplierAccountsByPkMutation,
      variables:{
        id
      }
    });
  }
}


